import React, { useState, useEffect } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Container from "./Container";
import Hover from "./Hover";
import HoverDetail from "./HoverDetail";
import Test from "./test";
// import Success from "../Success";

const Main = (props) => {
  const [code, setCode] = useState("");
  const [defields, setDefields] = useState([]);
  const [eventId, setEventId] = useState("");
  const [interactionId, setInteractionId] = useState("");

  useEffect(() => {
    setDefields(props.defields);
  }, [props.defields]);

  useEffect(() => {
    setEventId(props.eventId);
  }, [props.eventId]);

  useEffect(() => {
    setInteractionId(props.interactionId);
  }, [props.interactionId]);

  function handleCode(code) {
    setCode(code);
  }

  function natvigateToURL(url) {
    //console.log('move : ',url)
    window.location.href = url;
  }

  return (
    <HashRouter>
      <Routes>
        {/* <Route path="/success" element={<Success onChangeCode={(code) => handleCode(code)} />} /> */}
        <Route path="/success" />
        <Route path="/hover" element={<Hover />}/>
        <Route path="/test" element={<Test />}/>
        <Route path="/detail" element={<HoverDetail />}/>
        <Route exact path="/" element={<Container token={props.token} defields={defields} eventId={eventId} interactionId={interactionId} code={code} onMove={(url) => natvigateToURL(url)} />} />
      </Routes>
    </HashRouter>
  );
};

export default Main;
